module.exports = __webpack_public_path__ + "static/media/MosesFull.ee0f568b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Moses/MosesFull.mp3
// module id = 147
// module chunks = 0